/*
  landing-common-showcase.js — click-drag scrolling for the bottle lineup.

  A horizontal overflow container scrolls natively via trackpad swipe, touch and
  the scrollbar, but not a mouse wheel. Deliberately NOT hijacking the wheel:
  the row is long, so capturing wheel would trap the page scroll whenever the
  cursor sits over the section.

  The affordance is the swipe glyph set as the scroller's cursor. A drag starts
  anywhere in the row, bottles included; the threshold below separates a drag
  from a click and the capture-phase click handler swallows the drag-release.
*/
(function () {
  'use strict';

  const DRAG_THRESHOLD = 3;

  function canScroll(scroller) {
    return scroller.scrollWidth > scroller.clientWidth;
  }

  function bindDrag(scroller, surface) {
    const state = { down: false, moved: false, startX: 0, startLeft: 0 };

    surface.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || !canScroll(scroller)) return;
      // Reset first: any early return here would strand `moved` true and the
      // click handler below would swallow every later click on a bottle.
      state.moved = false;
      state.down = true;
      state.startX = event.clientX;
      state.startLeft = scroller.scrollLeft;
    });

    surface.addEventListener('pointermove', function (event) {
      if (!state.down) return;
      const dx = event.clientX - state.startX;
      if (!state.moved && Math.abs(dx) > DRAG_THRESHOLD) {
        state.moved = true;
        surface.dataset.dragging = 'true';
      }
      if (state.moved) scroller.scrollLeft = state.startLeft - dx;
    });

    function release() {
      state.down = false;
      delete surface.dataset.dragging;
    }

    surface.addEventListener('pointerup', release);
    surface.addEventListener('pointercancel', release);
    surface.addEventListener('pointerleave', release);

    // Images are natively draggable; without this a drag lifts a ghost image
    // instead of scrolling the row.
    surface.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    surface.addEventListener(
      'click',
      function (event) {
        if (!state.moved) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  function init() {
    document.querySelectorAll('[data-showcase-scroller]').forEach(function (scroller) {
      bindDrag(scroller, scroller);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
